import { render, staticRenderFns } from "./color-picker.vue?vue&type=template&id=5f2c2a1d&"
import script from "./color-picker.vue?vue&type=script&lang=ts&"
export * from "./color-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f2c2a1d')) {
      api.createRecord('5f2c2a1d', component.options)
    } else {
      api.reload('5f2c2a1d', component.options)
    }
    module.hot.accept("./color-picker.vue?vue&type=template&id=5f2c2a1d&", function () {
      api.rerender('5f2c2a1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/question-components/color-picker/color-picker.vue"
export default component.exports